import React from 'react';
import { Box, Image } from '@chakra-ui/react';

function CTAIcon({ url, pb }) {
  return (
    <Box
      pb={pb}
      w="100%"
      justifyContent="center"
      alignItems="center"
      display="flex"
      maxH="fit-content"
    >
      <Image
        alt="CTA Icon"
        src={url}
        w={{
          lg: '16px',
          md: '16px',
          base: '16px'
        }}
      />
    </Box>
  );
}

export default CTAIcon;
